import { DEFAULTS } from "./defaults";
import { AUDIO_TYPE } from "./types";
import { nodeViewRenderers } from "./viewer/nodeViewRenderers-loadable";
const pluginAudio = (config) => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: AUDIO_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginAudio
};
//# sourceMappingURL=viewer-loadable.js.map
